<template>
  <h4 class="overlay__title" v-html="title" />
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * 共通 オーバーレイタイトル テンプレート
 */
export default defineComponent({
  name: 'OverlayTitleParts',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" scoped>
.overlay__title {
  width: 100%;
  text-align: center;
  @include fontSetTextMedium(17);

  &:first-child {
    margin-top: 36px;
  }
}
</style>
